<template>
  <div>
    <div class="trades-head" v-bind:class="!record.online ? 'close': ''">
      <span @click="routeUser()" class="pointer hover">
        <Avatar
          v-if="record._user.avatar != null"
          class="trades-avatar"
          :src="`https://tradeinpool.com/upload/${record._user.avatar}.png`"
          :size="40"
        ></Avatar>
        <Avatar
          @click="routeUser()"
          v-else
          class="trades-avatar pointer"
          :username="record._user.username"
          :size="40"
        ></Avatar>
      </span>
      <span @click="routeDiary" class="trades-pl pointer">
        <span
          v-if="record.trades > 0"
          class="pl-center pointer"
          v-bind:class="record.pl > 0 ? 'up' : 'down'"
        >$ {{record.pl.toFixed(2)}}</span>
        <span v-else class="pl-center text-grey">N/A</span>
      </span>
      
      <v-tooltip bottom v-if="!record.online">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="20" class="mr-1 pointer" color="#4dbac0">link_off</v-icon>
        </template>
        <span class="pointer">{{record.updatedAt | lastAt}}</span>
      </v-tooltip>

      <b class="pointer" @click="routeDiary">{{record._user.username}}</b>
    </div>
    <div @click="routeDiary" class="trades-content pointer">
      {{record.trades | tradator }}
      |
      {{record.lots | sizator}}
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar
  },
  props: ["record"],
  data() {
    return {};
  },
  methods: {
    routeDiary() {
      return this.$router.push({
        path: "/journal/" + this.record._user.username
      });
    },
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record._user.username });
    }
  },
  computed: {
    timezone() {
      return this.$store.getters.timezone;
    }
  },
  filters: {
    desimator: function(value) {
      var newTicker = value.replace("[Sim]", "");
      newTicker = newTicker.split("-");
      return newTicker[0];
    },
    timator: function(value, timezone) {
      var millis = value * 1000;
      var newTime = moment.tz(millis, timezone).format("HH:mm");
      return newTime;
    },
    lastAt: function(value, timezone) {
      var newTime = moment.tz(value, timezone).fromNow();
      return newTime;
    },
    sizator: function(value) {
      if (value > 1) return value + " pcs";
      else return value + " pc";
    },
    tradator: function(value) {
      if (value > 1) return value + " trades";
      else return value + " trade";
    }
  }
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.loss {
  color: #e62163;
}

.profit {
  color: #79c04d;
}

.trades-head {
  width: 100%;
  position: relative;
  padding-right: 10px;
  padding-left: 55px;
  padding-top: 3px;
  height: 19px;
  float: left;
  color: #ffffff;
}

.trades-pl {
  float: right;
  font-size: 14px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
}

.pl-center {
  position: relative;
  top: 7px;
}

.trades-content {
  width: 100%;
  float: left;
  margin-left: 55px;
  color: #808f9c;
}
</style>
